import React from 'react';
import { Button, IconButton, Typography } from '@material-ui/core';
import CloseBox from '@material-ui/icons/Close';
import { FinalFormField, FinalFormSelect } from "../index.js";

export default ({ form, name, propertyOptions, operatorOptions, valueTypeOptions, onAddCondition }) => {
    const onDelCondition = (index) => { form.mutators.remove(name, index) }

    return (
        <div className="pb-4">
            <Typography className="mt-2" variant="h1">Conditions</Typography>

            {
                form.getState().values[name].map((_condition, index) => {
                    return (
                        <div className="condition_wrapper flex-row">
                            <div className="flex-3 overflow-hidden">
                                <FinalFormSelect
                                    form={form}
                                    name={`${name}.${index}.property`}
                                    label="Property"
                                    options={propertyOptions}
                                    fullWidth
                                />
                            </div>
                            <div className="flex-3 overflow-hidden">
                                <FinalFormSelect
                                    form={form}
                                    name={`${name}.${index}.operator`}
                                    label="Operator"
                                    options={operatorOptions}
                                    fullWidth
                                />
                            </div>
                            <div className="flex-3 overflow-hidden">
                                <FinalFormSelect
                                    form={form}
                                    name={`${name}.${index}.propertyType`}
                                    label={'Value type'}
                                    options={valueTypeOptions}
                                    fullWidth
                                />
                            </div>
                            <div className="flex-3">
                                <FinalFormField
                                    form={form}
                                    name={`${name}.${index}.value`}
                                    label="Value"
                                />
                            </div>
                            <div className="flex-1">
                                <IconButton onClick={() => {onDelCondition(index)}}><CloseBox/></IconButton>
                            </div>
                        </div>
                    )
                })
            }
            <Button fullWidth color="primary" variant="contained" onClick={onAddCondition}>Add more condition</Button>
        </div>
    )
}
